import React, { useState, useEffect } from 'react';
import { Briefcase, GraduationCap, Heart, Trophy, Loader2 } from 'lucide-react';
import JobApplicationModal from './JobApplicationModal';
import { careersAPI } from '../../services/api';

const CareersSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedJob, setSelectedJob] = useState(null);
    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const unsubscribe = careersAPI.subscribeToCareers((data) => {
            // Filter only active jobs for the public site
            const activeJobs = data.filter(job => job.is_active !== false);
            setJobs(activeJobs);
            setLoading(false);
        });

        return () => unsubscribe && unsubscribe();
    }, []);

    const handleApply = (job) => {
        setSelectedJob(job);
        setIsModalOpen(true);
    };

    return (
        <>
            <p className="text-lg leading-relaxed mb-6">
                Join our dynamic team and be part of a company that values talent, innovation, and growth.
            </p>
            <div className="bg-gradient-to-r from-[#2A9D8F] to-[#004a8b] text-white p-8 rounded-lg mb-6">
                <h3 className="text-2xl font-bold mb-2">Why Join Us?</h3>
                <p className="text-white/80 mb-4">Build your career with one of Sri Lanka's leading financial institutions.</p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
                    <div className="text-center">
                        <Briefcase className="mx-auto mb-2" size={28} />
                        <div className="text-sm">Career Growth</div>
                    </div>
                    <div className="text-center">
                        <GraduationCap className="mx-auto mb-2" size={28} />
                        <div className="text-sm">Learning & Development</div>
                    </div>
                    <div className="text-center">
                        <Heart className="mx-auto mb-2" size={28} />
                        <div className="text-sm">Work-Life Balance</div>
                    </div>
                    <div className="text-center">
                        <Trophy className="mx-auto mb-2" size={28} />
                        <div className="text-sm">Recognition</div>
                    </div>
                </div>
            </div>
            <h4 className="font-semibold text-gray-900 mb-4">Current Openings</h4>
            
            {loading ? (
                <div className="py-12 flex flex-col items-center justify-center text-gray-500">
                    <Loader2 className="w-8 h-8 animate-spin mb-2" />
                    <p>Loading opportunities...</p>
                </div>
            ) : jobs.length > 0 ? (
                <div className="space-y-3">
                    {jobs.map((job, idx) => (
                        <div key={job.id || idx} className="flex items-center justify-between p-4 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
                            <div>
                                <h5 className="font-semibold text-gray-900">{job.title}</h5>
                                <p className="text-gray-500 text-sm">{job.location} • {job.type}</p>
                            </div>
                            <button
                                onClick={() => handleApply(job)}
                                className="bg-[#2A9D8F] text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#004a8b] transition-colors"
                            >
                                Apply Now
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="p-8 text-center bg-gray-50 rounded-lg border border-dashed border-gray-300">
                    <p className="text-gray-500">No current openings available. Please check back later!</p>
                </div>
            )}

            {/* Job Application Modal */}
            <JobApplicationModal
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setSelectedJob(null);
                }}
                jobTitle={selectedJob?.title || ''}
            />
        </>
    );
};

export default CareersSection;
